module.exports = __webpack_public_path__ + "img/2.4931ebfd.jpg";